export const CompanySettionRouting = [
  {
    path: "/companySetting/companyInfo/form",
    name: "companySetting-companyInfo-form",
    meta: { title: "企业信息" },
    component: () =>
      import(
        /* webpackChunkName: "companyInfo-form" */ "@/views/companySetting/companyInfo/form/index.vue"
      ),
  },
];
